import Image from 'next/image';
import s from './DisplayBlock.module.css';
import { Button } from '@/components';
import { DisplayBlockEntity } from '@/types/model';
import useIsMobile from '@/hooks/use-is-mobile';
import { ImageLoader } from '@/lib/imageLoader';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';

const DisplayBlock = ({
  cta,
  description,
  image,
  title,
  altLayout,
  containerBg
}: DisplayBlockEntity) => {
  const t = useTranslations('common');
  const isMobile = useIsMobile();

  const flexDirection = isMobile
    ? altLayout === 'Right'
      ? 'column-reverse'
      : 'column'
    : altLayout === 'Right'
      ? 'row-reverse'
      : 'row';

  const handleClick = () => {
    window.location.href = cta.action!;
  };

  return (
    <motion.div
      id="displayBlock"
      whileInView={{ opacity: [0, 1], transition: { duration: 1, delay: 0.2 } }}
      className={s.container}
      style={{
        backgroundColor: `${containerBg ? 'var(--light-gray)' : 'var(--white)'}`
      }}>
      <div
        className={s.container__content}
        style={{
          flexDirection: flexDirection
        }}>
        <div className={s.container__content__image}>
          {image && (
            <Image
              src={ImageLoader({ src: image?.url })}
              fill
              sizes="(min-width: 62em) 345px, 620px"
              quality={65}
              alt="imagen representativa"
            />
          )}
        </div>
        <div className={s.container__content__description}>
          <h2 className={s.container__content__description__title}>{title}</h2>
          <p className={s.container__content__description__text}>{description}</p>
          {cta && <Button label={t('seeMore')} onClick={handleClick} />}
        </div>
      </div>
    </motion.div>
  );
};

export default DisplayBlock;
